import * as qiniu from 'qiniu-js'
import templateApi from '../../api/template.api'

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
	async getToken() {
		let { data } = await templateApi.getUpToken()
		if (data.isSuccess) {
			return data.data
		} else {
			throw '获取token失败'
		}
	},
	/**
	 *
	 * @param {*} param0
	 * @param {*} params
	 * @param {*} params.file
	 * @param {*} params.fileName
	 * @param {*} params.fname
	 */
	async uploadFile({ dispatch }, params) {
		let data = await dispatch('getToken')
		let observable = qiniu.upload(params.file, params.fileName, data.uptoken, {
			fname: params.fname
		})
		return new Promise((resolve, reject) => {
			observable.subscribe({
				err(res) {
					reject(res)
				},
				complete(res) {
					resolve(res)
				}
			})
		})
	}

}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
